import './chunk-6ea13200.js';
import './helpers.js';
import './chunk-17222463.js';
import './chunk-1f14bcfd.js';
import './chunk-d732d84c.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { I as Input } from './chunk-322704a2.js';
export { I as BInput } from './chunk-322704a2.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Input);
  }
};
use(Plugin);

export default Plugin;
